import AddOrderBox from "./AddOrderBox";
import OrderResult from "./OrderResult";

const CCOrder = () => {
  return (
    <div className="flex flex-row justify-start items-start gap-2 w-full">
      <AddOrderBox />
      <OrderResult />
    </div>
  );
};

export default CCOrder;
